module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-8003HD_white-4515f563cd81988a967d1f2d0cd39209.png";